import { render, staticRenderFns } from "./DemographicsChart.vue?vue&type=template&id=49a82296&scoped=true&"
import script from "./DemographicsChart.vue?vue&type=script&lang=js&"
export * from "./DemographicsChart.vue?vue&type=script&lang=js&"
import style0 from "./DemographicsChart.vue?vue&type=style&index=0&id=49a82296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a82296",
  null
  
)

export default component.exports